<template>
  <div class="flex flex-direction align-center justify-start viewConent view">
    <nav backgroundColor="#B43132"></nav>
    <div class="top-img"></div>
    <div class="text-center text-center-def">
      <div class="note">征集时间：</div>
      <div>即日起至2022年9月23日</div>
      <div class="note">主办：</div>
      <div>中共宜昌市委宣传部</div>
      <div>宜昌市农业农村局</div>
      <div>宜昌市乡村振兴局</div>
      <div>宜昌市文学艺术界联合会</div>
      <div class="note">承办：</div>
      <div>宜昌市全民阅读活动领导小组办公室</div>
      <div>宜昌市农家书屋工作小组办公室</div>
      <div>宜昌市文联作协工作部</div>
      <div class="note">协办：</div>
      <div>三峡日报融媒体中心</div>
      <div>三峡晚报</div>
      <div>《三峡文学》杂志社</div>
      <div>湖北省新华书店（集团）有限公司宜昌市分公司</div>
    </div>
    <div class="flex align-center justify-center margin-top-lg" style="position: relative;">
      <div>
        <wxlite class="hidden-sm-and-up" :activity="activity41458" :diySetting="activity41458"></wxlite>
      </div>
      <div class="margin-left-lg">
        <wxlite class="hidden-sm-and-up" :activity="activity43393" :diySetting="activity43393"></wxlite>
      </div>
    </div>
  </div>
</template>

<script>
  import App from '../util/comfun'
  import brand from '../components/brand.vue'
  import wxlite from '../components/wxlite.vue'
  //import 'element-ui/lib/theme-chalk/display.css';
  export default {
    data () {
      return {
        activity41458:{
          activityId:41458,
          className:'cla-41458-43393',
          buttonName:'我要投文稿',
          activityName:'中共宜昌市委宣传部',
          hideShareMenu:true,
        },
        activity43393:{
          activityId:43393,
          className:'cla-41458-43393',
          buttonName:'我要投视频',
          activityName:'中共宜昌市委宣传部',
          hideShareMenu:true,
        },
      }
    },
    components:{
      brand,
      wxlite,
    },
    methods:{

    },
    mounted(){
    },

  }
</script>

<style scoped>
  .viewConent{
    width: 100vw;
    height: 100vh;
    background: #B43132;
    position: relative;
    padding-top: 30px;
  }
  .top-img{
    width: 297px;
    height: 165px;
    background-image: url("https://assets.pfotoo.com/43393-41458/top.png?1");
    background-size: 100% 100%;
  }
  .viewConent:before{
    background-image: url("https://assets.pfotoo.com/43393-41458/bottom.png?1");
    background-size: 100% 100%;
    width: 100%;
    content: "";
    height: 255px;
    position: absolute;
    bottom: 0;
  }
  .text-center-def{
    font-size: 12px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    text-align: center;
    color: #fcedd0;
    line-height: 17px;
    letter-spacing: 0.8px;
  }
  .note{
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 600;
    text-align: center;
    color: #fcedd0;
    line-height: 20px;
    display: inline-block;
    margin-top: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/page_43393_41458.vue